import { produce } from "immer";
import {
  UPDATE_FILTERS,
  TOGGLE_FILTER_MODAL,
  SAVE_FILTER,
  SAVE_FILTER_SUCCESS,
  SAVE_FILTER_FAILURE,
  GET_FILTERS,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_FAILURE,
  TOGGLE_DELETE_FILTER,
  DELETE_FILTER,
  DELETE_FILTER_SUCCESS,
  DELETE_FILTER_FAILURE,
  UPDATE_SELECTED_FILTER,
} from "./constants";

export const initialState = {
  rotaFilters: {
    shift_type: null,
    roles: [],
  },
  filterModal: {
    open: false,
  },
  isSavingFilter: false,
  isGettingFilters: false,
  filters: [],
  deleteFilterModal: {
    open: false,
  },
  isDeletingFilter: false,
  selectedFilter: null,
};

const RotaFiltersReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case UPDATE_FILTERS:
        draft.rotaFilters = { ...draft.rotaFilters, ...action.payload };
        break;
      case TOGGLE_FILTER_MODAL:
        draft.filterModal = action.payload;
        break;
      case SAVE_FILTER:
        draft.isSavingFilter = true;
        break;
      case SAVE_FILTER_SUCCESS:
        draft.isSavingFilter = false;
        break;
      case SAVE_FILTER_FAILURE:
        draft.isSavingFilter = false;
        break;
      case GET_FILTERS:
        draft.isGettingFilters = true;
        break;
      case GET_FILTERS_SUCCESS:
        draft.isGettingFilters = false;
        draft.filters = action.payload;
        break;
      case GET_FILTERS_FAILURE:
        draft.isGettingFilters = false;
        break;

      case TOGGLE_DELETE_FILTER:
        draft.deleteFilterModal = action.payload;
        break;
      case DELETE_FILTER:
        draft.isDeletingFilter = true;
        break;
      case DELETE_FILTER_SUCCESS:
        draft.isDeletingFilter = false;
        break;
      case DELETE_FILTER_FAILURE:
        draft.isDeletingFilter = false;
        break;

      case UPDATE_SELECTED_FILTER:
        draft.selectedFilter = action.payload;
        break;

      default:
        return state;
    }
  });

export default RotaFiltersReducer;
